Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GikiAnalyticsEventType = void 0;
var GikiAnalyticsEventType = exports.GikiAnalyticsEventType = function (GikiAnalyticsEventType) {
  GikiAnalyticsEventType["stepCommitmentPending"] = "step.commitment.pending";
  GikiAnalyticsEventType["stepCommitmentSuccessful"] = "step.commitment.successful";
  GikiAnalyticsEventType["stepCommitmentAbandoned"] = "step.commitment.abandoned";
  GikiAnalyticsEventType["stepCommitmentExisting"] = "step.commitment.existing";
  GikiAnalyticsEventType["stepCommitmentExistingCheck"] = "step.commitment.existing_check";
  GikiAnalyticsEventType["stepCommitmentSuccessfulLimitExceeded"] = "step.commitment.successful_limit_exceeded";
  GikiAnalyticsEventType["stepCommitmentSuccessfulLimitReached"] = "step.commitment.successful_limit_reached";
  GikiAnalyticsEventType["stepLearnMore"] = "step.learn_more";
  GikiAnalyticsEventType["stepSuppress"] = "step.suppress";
  GikiAnalyticsEventType["stepCard"] = "step.card";
  GikiAnalyticsEventType["stepCategory"] = "step.category";
  GikiAnalyticsEventType["footprintCard"] = "footprint.card";
  GikiAnalyticsEventType["footprintSuppress"] = "footprint.suppress";
  GikiAnalyticsEventType["footprintUpdate"] = "footprint.update";
  GikiAnalyticsEventType["footprintCategory"] = "footprint.category";
  return GikiAnalyticsEventType;
}({});